import { ReactElement } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import { MUNICIPAL_PROPERTY_BASE_PATH } from "./municipal-property-base-path";

export function MunicipalPropertyLegacyRedirectPage(): ReactElement {
  const { workspaceUrl, "*": path = "" } = useParams();
  const { search, hash } = useLocation();
  return (
    <Navigate
      to={`/${workspaceUrl}/${MUNICIPAL_PROPERTY_BASE_PATH}/${path}${search}${hash}`}
      replace
    />
  );
}
